namespace $.$$ {
	
	type MultimodalContent = {
		type: 'text'
		text: string
	} | {
		type: 'image_url'
		image_url: { url: string }
	} | {
		type: 'input_audio'
		input_audio: { data: string, format: string }
	}
	
		export class $bog_bot extends $.$bog_bot {
		
		// Override rules to substitute language and ensure "json" keyword for OpenAI
		@ $mol_mem
		override rules() {
			let rules = super.rules().replaceAll( '{lang}', this.$.$mol_locale.lang() )
			// GitHub Models require the word "json" (lower-case) in any message when using response_format=json_object
			if( !rules.toLowerCase().includes('json') ) {
				rules = rules + ' Ответ должен быть в формате json.'
			}
			console.log('📜 rules:', rules.substring(0, 200) + '...')
			return rules
		}
		
		// Override digest to store/retrieve from session
		override digest( next?: string ) {
			if( next !== undefined ) {
				console.log('📝 digest() WRITE:', next)
			}
			const result = this.$.$mol_state_session.value( 'digest', next ) ?? ''
			if( next === undefined ) {
				console.log('📖 digest() READ:', result)
			}
			return result
		}
		
		// Override messages to add logging
		override messages() {
			console.log('📋 messages() called')
			const history = this.history()
			console.log('📋 history length:', history.length)
			const result = history.map( (_,i)=> this.Message(i) )
			console.log('📋 messages result:', result)
			return result
		}
		
		// Override history to support multimodal messages (not just strings)
		@ $mol_mem
		history( next?: any[] ): any[] {
			if( next !== undefined ) {
				console.log('📝 history() WRITE called, length:', next.length, 'content:', next)
			} else {
				const current = this.$.$mol_state_session.value( 'history' ) ?? $mol_maybe( this.$.$mol_state_arg.value( 'prompt' ) || null ) as any[]
				console.log('📖 history() READ called, length:', (current as any[]).length)
			}
			// Call parent's storage directly like in $gd_bot
			return this.$.$mol_state_session.value( 'history', next ) ?? $mol_maybe( this.$.$mol_state_arg.value( 'prompt' ) || null )
		}
		
		@ $mol_mem
		attached_images( next?: File[] ) {
			return next ?? []
		}
		
		@ $mol_mem
		attached_audio( next?: File[] ) {
			return next ?? []
		}
		
		media_recorder?: MediaRecorder
		audio_chunks: Blob[] = []
		
		@ $mol_action
		image_upload() {
			const input = document.createElement('input')
			input.type = 'file'
			input.accept = 'image/*'
			input.multiple = true
			input.onchange = () => {
				const files = Array.from( input.files ?? [] )
				this.attached_images([ ... this.attached_images(), ... files ])
			}
			input.click()
		}
		
		// Paste screenshot from clipboard
		@ $mol_action
		async paste_screenshot() {
			try {
				const items = await navigator.clipboard.read()
				for( const item of items ) {
					for( const type of item.types ) {
						if( type.startsWith('image/') ) {
							const blob = await item.getType( type )
							const file = new File([ blob ], `screenshot-${Date.now()}.png`, { type })
							this.attached_images([ ... this.attached_images(), file ])
						}
					}
				}
			} catch( error ) {
				console.error( 'Failed to read clipboard:', error )
			}
		}
		
		// Enable paste event handler
		override dom_tree() {
			const tree = super.dom_tree()
			
			// Add paste event listener
			if( typeof document !== 'undefined' ) {
				document.addEventListener('paste', async ( event ) => {
					const items = event.clipboardData?.items
					if( !items ) return
					
					for( const item of Array.from( items ) ) {
						if( item.type.startsWith('image/') ) {
							event.preventDefault()
							const blob = item.getAsFile()
							if( blob ) {
								this.attached_images([ ... this.attached_images(), blob ])
							}
						}
					}
				})
			}
			
			return tree
		}
		
		// Audio recording with pointer events
		@ $mol_mem
		is_recording( next?: boolean ) {
			return next ?? false
		}
		
		// Override Prompt_audio_record to attach pointer event listeners
		@ $mol_mem
		override Prompt_audio_record() {
			const button = super.Prompt_audio_record()
			const node = button.dom_node() as HTMLElement
			
			node.addEventListener('pointerdown', ( event ) => {
				console.log('🎤 pointerdown event')
				event.preventDefault()
				this.is_recording( true )
				this.start_audio_recording()
			})
			
			node.addEventListener('pointerup', ( event ) => {
				console.log('🎤 pointerup event')
				event.preventDefault()
				this.is_recording( false )
				this.stop_audio_recording()
			})
			
			node.addEventListener('pointercancel', ( event ) => {
				console.log('🎤 pointercancel event')
				event.preventDefault()
				this.is_recording( false )
				this.stop_audio_recording()
			})
			
			return button
		}
		
		@ $mol_action
		async start_audio_recording() {
			try {
				console.log('🎤 Requesting microphone access...')
				const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
				console.log('🎤 Microphone access granted')
				
				this.media_recorder = new MediaRecorder( stream )
				this.audio_chunks = []
				
				this.media_recorder.ondataavailable = ( event ) => {
					console.log('🎤 Audio data available:', event.data.size, 'bytes')
					if( event.data.size > 0 ) {
						this.audio_chunks.push( event.data )
					}
				}
				
				this.media_recorder.onstop = () => {
					console.log('🎤 Recording stopped, chunks:', this.audio_chunks.length)
					const audioBlob = new Blob( this.audio_chunks, { type: 'audio/webm' })
					const audioFile = new File([ audioBlob ], `recording-${Date.now()}.webm`, { type: 'audio/webm' })
					console.log('🎤 Audio file created:', audioFile.name, audioFile.size, 'bytes')
					this.attached_audio([ ... this.attached_audio(), audioFile ])
					console.log('🎤 Total attached audio files:', this.attached_audio().length)
					
					// Stop all tracks
					stream.getTracks().forEach( track => track.stop() )
				}
				
				this.media_recorder.start()
				console.log('🎤 MediaRecorder started')
				
			} catch( error ) {
				console.error('❌ Failed to start recording:', error)
			}
		}
		
		@ $mol_action
		stop_audio_recording() {
			console.log('🎤 stop_audio_recording called, recorder state:', this.media_recorder?.state)
			if( this.media_recorder && this.media_recorder.state !== 'inactive' ) {
				this.media_recorder.stop()
				console.log('🎤 Recorder stopped')
			}
		}
		
		@ $mol_mem
		override Recording_indicator() {
			const indicator = super.Recording_indicator()
			const node = indicator.dom_node() as HTMLElement
			if( !this.is_recording() ) {
				node.style.display = 'none'
			} else {
				node.style.display = ''
			}
			return indicator
		}
		
		// Convert File to base64 for API
		async file_to_base64( file: File ): Promise<string> {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => {
					const result = reader.result as string
					const base64 = result.split(',')[1]
					resolve( base64 )
				}
				reader.onerror = reject
				reader.readAsDataURL( file )
			})
		}
		
		// Preview attachments
		@ $mol_mem
		override attachments_preview(): readonly any[] {
			const preview: any[] = []
			
			this.attached_images().forEach( (_, index) => {
				preview.push( this.Attached_image_wrap( index ) )
			})
			
			this.attached_audio().forEach( (_, index) => {
				preview.push( this.Attached_audio_wrap( index ) )
			})
			
			return preview
		}
		
		@ $mol_mem_key
		attached_image_uri( index: number ): string {
			const file = this.attached_images()[ index ]
			if( !file ) return ''
			return URL.createObjectURL( file )
		}
		
		@ $mol_mem_key
		attached_audio_name( index: number ): string[] {
			const file = this.attached_audio()[ index ]
			if( !file ) return []
			return [ file.name ]
		}
		
		@ $mol_action
		remove_image( index: number ) {
			const images = this.attached_images()
			this.attached_images( images.filter( (_, i) => i !== index ) )
		}
		
		@ $mol_action
		remove_audio( index: number ) {
			const audio = this.attached_audio()
			this.attached_audio( audio.filter( (_, i) => i !== index ) )
		}
		
		// Build multimodal content array
		async build_multimodal_content( text: string ): Promise<MultimodalContent[]> {
			console.log('🏗️ build_multimodal_content started')
			console.log('🏗️ Text:', text)
			console.log('🏗️ Images to process:', this.attached_images().length)
			console.log('🏗️ Audio to process:', this.attached_audio().length)
			
			const content: MultimodalContent[] = []
			
			// Add text
			if( text ) {
				console.log('🏗️ Adding text to content')
				content.push({ type: 'text', text })
			}
			
			// Add images
			for( const img of this.attached_images() ) {
				console.log('🏗️ Processing image:', img.name, img.size, 'bytes')
				const base64 = await this.file_to_base64( img )
				console.log('🏗️ Image converted to base64, length:', base64.length)
				content.push({
					type: 'image_url',
					image_url: { url: `data:${img.type};base64,${base64}` }
				})
			}
			
			// Add audio
			for( const audio of this.attached_audio() ) {
				console.log('🏗️ Processing audio:', audio.name, audio.size, 'bytes')
				const base64 = await this.file_to_base64( audio )
				const format = audio.type.split('/')[1] || 'wav'
				console.log('🏗️ Audio converted to base64, format:', format, 'length:', base64.length)
				content.push({
					type: 'input_audio',
					input_audio: { data: base64, format }
				})
			}
			
			console.log('🏗️ build_multimodal_content finished, items:', content.length)
			return content
		}
		
		// Override communication to support multimodal
		@ $mol_mem
		override communication() {
			console.log('💬💬💬 COMMUNICATION() CALLED 💬💬💬')
			
			const history = this.history()
			console.log('💬 communication() called, history length:', history.length)
			
			if( history.length % 2 === 0 ) {
				console.log('💬 History length is even, skipping')
				return
			}
			
			console.log('💬 Last message:', history[history.length - 1])
			
			const model = this.Model() as $bog_bot_model
			const fork = model.fork() as $bog_bot_model
			
			console.log('💬 Building history for model...')
			
			// Build history with multimodal support
			for( let i = 0; i < history.length; ++i ) {
				const msg = history[i]
				
				console.log(`💬 Processing message ${i}:`, typeof msg, Array.isArray(msg) ? 'array' : '')
				
				// Check if message contains multimodal data
				if( typeof msg === 'string' ) {
					if( i % 2 ) {
						console.log(`💬 [${i}] Assistant message (tell)`)
						fork.tell({ response: msg, digest: null, title: null })
					} else {
						console.log(`💬 [${i}] User text message (ask)`)
						fork.ask( msg )
					}
				} else {
					// Multimodal message
					if( i % 2 ) {
						console.log(`💬 [${i}] Assistant multimodal (tell)`)
						fork.tell( msg )
					} else {
						console.log(`💬 [${i}] User multimodal message (ask_multimodal)`)
						fork.ask_multimodal( msg )
					}
				}
			}
			
			console.log('💬 Sending request to model...')
			
			try {
				const resp = fork.response()
				console.log('💬 Response received FULL:', JSON.stringify(resp, null, 2))
				console.log('💬 resp.title:', resp?.title)
				console.log('💬 resp.digest:', resp?.digest)
				console.log('💬 resp.response:', resp?.response)
				
				if( resp?.title ) {
					console.log('✅ Setting title:', resp.title)
					this.dialog_title( resp.title )
				} else {
					console.log('❌ No title in response')
				}
				
				// Prepare updated history including assistant response
				const updated_history = [ ... history, resp?.response ]
				
				if( resp?.digest ) {
					console.log('✅ Setting digest:', resp.digest)
					// Convert digest to string if it's an object
					const digestStr = typeof resp.digest === 'string' 
						? resp.digest 
						: JSON.stringify(resp.digest, null, 2)
					this.digest( digestStr )
				} else {
					console.log('❌ No digest in response — generating fallback')
					this.digest( this.fallback_digest( updated_history ) )
				}
				this.history( updated_history )
			} catch( error: any ) {
				console.error('❌ Communication error:', error)
				if( $mol_fail_log( error ) ) {
					this.history([ ... history, '📛' + error.message ])
				}
			}
			
		}
		
		// Override prompt_submit to include attachments
		override prompt_submit() {
			console.log('🔥🔥🔥 PROMPT_SUBMIT CALLED 🔥🔥🔥')
			console.log('Stack trace:', new Error().stack)
			
			const text = this.prompt_text()
			const images = this.attached_images()
			const audio = this.attached_audio()
			
			console.log('📤 Text:', text)
			console.log('📤 Images:', images.length)
			console.log('📤 Audio:', audio.length)
			
			// If no text and no attachments, do nothing
			if( !text && images.length === 0 && audio.length === 0 ) {
				console.log('📤 Nothing to send')
				return
			}
			
			// If no attachments, use same logic as parent but with our history()
			if( images.length === 0 && audio.length === 0 ) {
				console.log('📤 No attachments, using same logic as parent')
				console.log('📤 Current history:', this.history())
				console.log('📤 Text to add:', text)
				
				// Same as parent: this.history([ ... this.history(), ... $mol_maybe( this.prompt_text() || null ) ])
				this.history([ ... this.history(), ... $mol_maybe( text || null ) ])
				
				console.log('📤 After history update:', this.history())
				this.prompt_text( '' )
				console.log('📤 Text cleared')
				return
			}
			
			console.log('📤 Building multimodal content...')
			
			// Build multimodal message
			this.build_multimodal_content( text ).then( content => {
				console.log('📤 Multimodal content built:', content)
				console.log('📤 Content items:', content.length)
				
				const message = content.length === 1 && content[0].type === 'text'
					? text  // Simple text message
					: content  // Multimodal message
				
				console.log('📤 Adding to history:', message)
				
				// Use type assertion for history in async context
				const self = this as any as $bog_bot
				const current_history = self.history()
				self.history([
					... current_history,
					message
				])
				
				console.log('📤 History updated')
				
				self.prompt_text( '' )
				self.attached_images([])
				self.attached_audio([])
				
				console.log('📤 Cleared attachments')
			}).catch( error => {
				console.error('❌ Error building multimodal content:', error)
			})
		}

		// Build a simple digest when model omits it
		fallback_digest( history: any[] ): string {
			const lines: string[] = []
			for( let i = 0; i < history.length; ++i ) {
				const msg = history[i]
				let text = ''
				if( typeof msg === 'string' ) text = msg
				else if( Array.isArray( msg ) ) {
					// concatenate text parts from multimodal content
					text = msg
						.filter( (p: any)=> p?.type === 'text' )
						.map( (p: any)=> p.text )
						.join(' ')
				}
				text = (text ?? '').replace(/\s+/g, ' ').trim()
				if( !text || text.startsWith('📛') ) continue
				const who = i % 2 ? '🤖' : '🙂'
				lines.push(`${who} ${text}`)
			}
			const head = 'Краткий пересказ диалога:'
			return [ head, ... lines.slice( -10 ) ].join('\n')
		}
		
	}
}
